import EmploymentConnectionEdit from "../Edits/EmploymentConnectionEdit";
import CmModal from "../Controls/CmModal";

export default function EmploymentConnectionEditModal({
  employmentId = 0,
  organizationOptions = [],
  onClose,
}) {
  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title="Employment Connection"
      size="form"
      testId="employment-connection-edit-modal"
    >
      <EmploymentConnectionEdit
        employmentId={employmentId}
        organizationOptions={organizationOptions}
        onClose={onClose}
      />
    </CmModal>
  );
}
